/**
 * PostHog WOM event tracking - Milletmatters
 * Tracks: add to cart, checkout, social proof viewed, write a review, load more, prev/next image in review modals, review image clicks.
 * No pagination, no filters, social proof banner is not clickable.
 */
(function () {
  function capture(eventName, properties) {
    try {
      if (typeof window.posthog === 'undefined' || typeof window.posthog.capture !== 'function') return;
      window.posthog.capture(eventName, properties || {});
    } catch (e) {
      console.warn('[PostHog WOM]', e);
    }
  }

  function getText(el) {
    if (!el) return '';
    return (el.textContent || '').trim();
  }

  function getTextUp(el, maxDepth) {
    var depth = (maxDepth === undefined) ? 5 : maxDepth;
    var node = el;
    while (node && depth-- > 0) {
      var t = getText(node);
      if (t && t.length > 2) return t;
      node = node.parentElement || node.parentNode;
    }
    return getText(el);
  }

  function getPathText(path, maxLen) {
    var out = '';
    var len = (maxLen === undefined) ? 500 : maxLen;
    for (var i = 0; i < path.length && out.length < len; i++) {
      var node = path[i];
      if (node && node.nodeType === 1) {
        var t = getText(node);
        if (t && t.length < 200) out += ' ' + t;
      }
    }
    return out.trim();
  }

  function pathHas(path, attr, value) {
    if (!path || !path.length) return false;
    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (!node || !node.getAttribute) continue;
      var v = node.getAttribute(attr);
      if (value === undefined || value === '') { if (v !== null && v !== undefined) return true; }
      else if (v === value) return true;
    }
    return false;
  }

  function pathHasId(path, id) {
    return pathHas(path, 'id', id);
  }

  function pathHasClass(path, className) {
    if (!path || !path.length) return false;
    for (var i = 0; i < path.length; i++) {
      var n = path[i];
      if (!n || !n.className || typeof n.className !== 'string') continue;
      if (n.className.indexOf(className) !== -1) return true;
    }
    return false;
  }

  function isInsideReviewsWidget(path) {
    return pathHasId(path, 'reviews-pagination') ||
           pathHasId(path, 'reviews-list') ||
           pathHasId(path, 'reviews-breakdown-detailed') ||
           pathHasId(path, 'wom-reviews-container');
  }

  function getProductContextFromForm(form) {
    var ctx = { productHandle: '', variantId: '' };
    if (!form) return ctx;
    var idInput = form.querySelector && form.querySelector('input[name="id"]');
    if (idInput && idInput.value) ctx.variantId = String(idInput.value);
    var picker = form.querySelector && form.querySelector('variant-picker[handle]');
    if (picker && picker.getAttribute && picker.getAttribute('handle')) ctx.productHandle = picker.getAttribute('handle');
    if (!ctx.productHandle && typeof window.location !== 'undefined' && window.location.pathname) {
      var m = window.location.pathname.match(/\/products\/([^\/\?]+)/);
      if (m) ctx.productHandle = m[1];
    }
    if (!ctx.productHandle && form.closest) {
      var card = form.closest('.product-card') || form.closest('product-card');
      if (card && card.getAttribute && card.getAttribute('handle')) ctx.productHandle = card.getAttribute('handle');
    }
    return ctx;
  }

  var lastWriteReviewFire = 0;
  var lastLoadMoreFire = 0;
  var DEBOUNCE_MS = 800;

  document.addEventListener('click', function (e) {
    var target = e.target;
    var path = (e.composedPath && e.composedPath()) || [];
    var pathText = getPathText(path);

    var clickEl = target && target.nodeType === 1 ? target : (target && (target.parentElement || target.parentNode));
    if (!clickEl || clickEl.nodeType !== 1) clickEl = target;
    var btn = clickEl.closest && (clickEl.closest('button') || clickEl.closest('a') || clickEl.closest('[role="button"]'));
    var label = (target.getAttribute && target.getAttribute('aria-label')) || '';
    if (btn) label = label || (btn.getAttribute && btn.getAttribute('aria-label')) || '';
    var text = getTextUp(btn || target);
    if (!text) text = getText(target);
    var combinedText = (text + ' ' + pathText).toLowerCase();

    // ---- Buy now / dynamic checkout (Shopify payment button) ----
    var inPaymentButton = path.some(function (node) {
      return node && node.classList && node.classList.contains && (node.classList.contains('shopify-payment-button') || node.classList.contains('shopify-payment-button__button'));
    });
    if (inPaymentButton) {
      var payForm = (target.closest && target.closest('form')) || (btn && btn.closest && btn.closest('form'));
      var payCtx = getProductContextFromForm(payForm);
      capture('checkout_clicked', { source: 'buy_now', productHandle: payCtx.productHandle, variantId: payCtx.variantId });
      return;
    }

    // ---- Add to cart (product-form uses AJAX, so detect by class/data-type not form action) ----
    var submitEl = clickEl && clickEl.closest && (clickEl.closest('button[type="submit"]') || clickEl.closest('input[type="submit"]'));
    var form = submitEl && submitEl.form ? submitEl.form : (clickEl && clickEl.closest && clickEl.closest('form'));
    var isAddToCartForm = form && (
      form.getAttribute && form.getAttribute('data-type') === 'add-to-cart-form'
    );
    var isAddToCartButton = pathHasClass(path, 'product-form__submit') || pathHasClass(path, 'ecom-collection__product-submit') || pathHasClass(path, 'custom-add-to-cart-btn');
    if ((submitEl && isAddToCartForm) || isAddToCartButton) {
      var insidePay = form && form.querySelector && form.querySelector('.shopify-payment-button') && (form.querySelector('.shopify-payment-button').contains(target) || (submitEl && form.querySelector('.shopify-payment-button').contains(submitEl)));
      if (!insidePay) {
        var atcCtx = getProductContextFromForm(form);
        capture('add_to_cart_clicked', { productHandle: atcCtx.productHandle, variantId: atcCtx.variantId });
        return;
      }
    }

    // ---- Add to cart link (e.g. cart/add?id=...) ----
    var atcLink = clickEl && clickEl.closest && clickEl.closest('a');
    if (atcLink && atcLink.getAttribute) {
      var href = (atcLink.getAttribute('href') || '').toLowerCase();
      if (href.indexOf('cart/add') !== -1) {
        var idMatch = href.match(/[?&]id=(\d+)/);
        capture('add_to_cart_clicked', { source: 'link', variantId: idMatch ? idMatch[1] : '' });
        return;
      }
    }

    // ---- Checkout (cart drawer, cart page, cart notification) ----
    var isCheckoutBtn = (btn && btn.getAttribute && btn.getAttribute('name') === 'checkout') ||
      pathHasId(path, 'checkout') ||
      pathHasClass(path, 'cart__checkout-button');
    if (isCheckoutBtn) {
      capture('checkout_clicked', { source: 'cart' });
      return;
    }
    var checkoutLink = clickEl && clickEl.closest && clickEl.closest('a');
    if (checkoutLink && checkoutLink.getAttribute && (checkoutLink.getAttribute('href') || '').indexOf('/checkout') !== -1) {
      capture('checkout_clicked', { source: 'link' });
      return;
    }

    // ---- Prev/Next image in review modal (#prev-image, #next-image, #prev-arrow, #next-arrow) ----
    if (label === 'Previous image' || (btn && btn.getAttribute && btn.getAttribute('aria-label') === 'Previous image') ||
        pathHasId(path, 'prev-image') || pathHasId(path, 'prev-arrow')) {
      capture('wom_review_image_prev_clicked', {});
      return;
    }
    if (label === 'Next image' || (btn && btn.getAttribute && btn.getAttribute('aria-label') === 'Next image') ||
        pathHasId(path, 'next-image') || pathHasId(path, 'next-arrow')) {
      capture('wom_review_image_next_clicked', {});
      return;
    }

    // ---- From here: only consider clicks inside reviews widget ----
    if (!isInsideReviewsWidget(path)) return;

    // ---- Load more / Show more reviews (check FIRST - class-based, "Show More" has "review" in text) ----
    if (pathHasClass(path, 'show-more-btn')) {
      if (Date.now() - lastLoadMoreFire > DEBOUNCE_MS) {
        lastLoadMoreFire = Date.now();
        capture('wom_load_more_clicked', {});
      }
      return;
    }

    // ---- Write a review (class-based to avoid matching "Show More Reviews") ----
    if (pathHasClass(path, 'write-review-btn')) {
      if (Date.now() - lastWriteReviewFire > DEBOUNCE_MS) {
        lastWriteReviewFire = Date.now();
        capture('wom_write_review_clicked', {});
      }
      return;
    }

    // ---- Review image clicked (customer images, desktop/mobile food images) ----
    if (pathHas(path, 'data-wom-review-card') && (target.tagName === 'IMG' || pathHasClass(path, 'wom-review-images-gallery'))) {
      capture('wom_review_image_clicked', {});
      return;
    }
    if (pathHasClass(path, 'customer-image-item') || pathHasClass(path, 'desktop-food-image') || pathHasClass(path, 'mobile-food-below')) {
      capture('wom_review_image_clicked', {});
      return;
    }
  }, true);

  // ---- Social proof viewed (when banner enters viewport) ----
  function trackSocialProofViewed() {
    var el = document.getElementById('social-proof-banner');
    if (!el || !window.IntersectionObserver) return;
    var fired = false;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (fired || !entry.isIntersecting) return;
        fired = true;
        capture('wom_social_proof_viewed', {});
        observer.disconnect();
      });
    }, { threshold: 0.5, rootMargin: '0px' });
    observer.observe(el);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackSocialProofViewed);
  } else {
    trackSocialProofViewed();
  }
})();
